"use strict";
/**
 * This file has been generated
 * DO NOT EDIT, IT MAY BE OVERWRITTEN
 */
Object.defineProperty(exports, "__esModule", { value: true });
var VariableFormat;
(function (VariableFormat) {
    VariableFormat[VariableFormat["_1_BIT"] = 0] = "_1_BIT";
    VariableFormat[VariableFormat["_8_BITS"] = 1] = "_8_BITS";
    VariableFormat[VariableFormat["_16_BITS"] = 2] = "_16_BITS";
    VariableFormat[VariableFormat["_32_BITS"] = 3] = "_32_BITS";
})(VariableFormat = exports.VariableFormat || (exports.VariableFormat = {}));
var VariableType;
(function (VariableType) {
    VariableType[VariableType["BOOLEAN"] = 0] = "BOOLEAN";
    VariableType[VariableType["INT8"] = 1] = "INT8";
    VariableType[VariableType["INT16"] = 2] = "INT16";
    VariableType[VariableType["INT32"] = 3] = "INT32";
    VariableType[VariableType["UINT8"] = 33] = "UINT8";
    VariableType[VariableType["UINT16"] = 34] = "UINT16";
    VariableType[VariableType["UINT32"] = 35] = "UINT32";
    VariableType[VariableType["FLOAT32"] = 19] = "FLOAT32";
    VariableType[VariableType["STRING"] = 128] = "STRING";
})(VariableType = exports.VariableType || (exports.VariableType = {}));
var AvailablePowerSource;
(function (AvailablePowerSource) {
    AvailablePowerSource[AvailablePowerSource["DC_POWER"] = 1] = "DC_POWER";
    AvailablePowerSource[AvailablePowerSource["S3P"] = 16] = "S3P";
    AvailablePowerSource[AvailablePowerSource["AC_EXTERNAL_POWER"] = 32] = "AC_EXTERNAL_POWER";
})(AvailablePowerSource = exports.AvailablePowerSource || (exports.AvailablePowerSource = {}));
var FirmwareState;
(function (FirmwareState) {
    FirmwareState[FirmwareState["NORMAL"] = 1] = "NORMAL";
    FirmwareState[FirmwareState["UPDATING"] = 2] = "UPDATING";
    FirmwareState[FirmwareState["UPDATED"] = 4] = "UPDATED";
})(FirmwareState = exports.FirmwareState || (exports.FirmwareState = {}));
var FirmwareUpdateResult;
(function (FirmwareUpdateResult) {
    FirmwareUpdateResult[FirmwareUpdateResult["DEFAULT_VALUE"] = 0] = "DEFAULT_VALUE";
    FirmwareUpdateResult[FirmwareUpdateResult["UPDATE_SUCCESSFUL"] = 1] = "UPDATE_SUCCESSFUL";
    FirmwareUpdateResult[FirmwareUpdateResult["NOT_ENOUGH_MEMORY"] = 2] = "NOT_ENOUGH_MEMORY";
    FirmwareUpdateResult[FirmwareUpdateResult["OUT_OF_MEMORY"] = 4] = "OUT_OF_MEMORY";
    FirmwareUpdateResult[FirmwareUpdateResult["CONNECTION_LOST"] = 8] = "CONNECTION_LOST";
    FirmwareUpdateResult[FirmwareUpdateResult["CRC_CHECK_FAILURE"] = 16] = "CRC_CHECK_FAILURE";
    FirmwareUpdateResult[FirmwareUpdateResult["UNSUPPORTED_PACKAGE_TYPE"] = 32] = "UNSUPPORTED_PACKAGE_TYPE";
    FirmwareUpdateResult[FirmwareUpdateResult["INVALID_URI"] = 64] = "INVALID_URI";
})(FirmwareUpdateResult = exports.FirmwareUpdateResult || (exports.FirmwareUpdateResult = {}));
var HostProtocol;
(function (HostProtocol) {
    HostProtocol[HostProtocol["NFC"] = 1] = "NFC";
    HostProtocol[HostProtocol["BLUETOOTH"] = 2] = "BLUETOOTH";
    HostProtocol[HostProtocol["GSM"] = 4] = "GSM";
    HostProtocol[HostProtocol["USB_RLINK"] = 8] = "USB_RLINK";
    HostProtocol[HostProtocol["USB_CMISIS_DAP"] = 16] = "USB_CMISIS_DAP";
    HostProtocol[HostProtocol["WIFI"] = 32] = "WIFI";
    HostProtocol[HostProtocol["BLE"] = 64] = "BLE";
})(HostProtocol = exports.HostProtocol || (exports.HostProtocol = {}));
var LowPowerOptimisationLevel;
(function (LowPowerOptimisationLevel) {
    LowPowerOptimisationLevel[LowPowerOptimisationLevel["NO"] = 0] = "NO";
    LowPowerOptimisationLevel[LowPowerOptimisationLevel["STANDBY"] = 2] = "STANDBY";
    LowPowerOptimisationLevel[LowPowerOptimisationLevel["SHUTDOWN"] = 3] = "SHUTDOWN";
})(LowPowerOptimisationLevel = exports.LowPowerOptimisationLevel || (exports.LowPowerOptimisationLevel = {}));
var NetworkMode;
(function (NetworkMode) {
    NetworkMode[NetworkMode["PEER_TO_PEER"] = 0] = "PEER_TO_PEER";
    NetworkMode[NetworkMode["INFRASTRUCTURE_ONLY"] = 1] = "INFRASTRUCTURE_ONLY";
    NetworkMode[NetworkMode["INFRASTRUCTURE_CLOUD"] = 2] = "INFRASTRUCTURE_CLOUD";
})(NetworkMode = exports.NetworkMode || (exports.NetworkMode = {}));
var CloudConnectionMode;
(function (CloudConnectionMode) {
    CloudConnectionMode[CloudConnectionMode["GENERIC"] = 0] = "GENERIC";
    CloudConnectionMode[CloudConnectionMode["IBM_BLUEMIX"] = 1] = "IBM_BLUEMIX";
    CloudConnectionMode[CloudConnectionMode["MICROSOFT_AZURE"] = 2] = "MICROSOFT_AZURE";
    CloudConnectionMode[CloudConnectionMode["AMAZON_AWS"] = 4] = "AMAZON_AWS";
})(CloudConnectionMode = exports.CloudConnectionMode || (exports.CloudConnectionMode = {}));
var TargetProtocol;
(function (TargetProtocol) {
    TargetProtocol[TargetProtocol["SWD"] = 0] = "SWD";
    TargetProtocol[TargetProtocol["S3P"] = 1] = "S3P";
    TargetProtocol[TargetProtocol["JTAG"] = 2] = "JTAG";
    TargetProtocol[TargetProtocol["MODBUS"] = 3] = "MODBUS";
    TargetProtocol[TargetProtocol["GPIO"] = 4] = "GPIO";
    TargetProtocol[TargetProtocol["SERIAL_STANDARD"] = 5] = "SERIAL_STANDARD";
    TargetProtocol[TargetProtocol["SERIAL_VIA_TAPNPASS"] = 6] = "SERIAL_VIA_TAPNPASS";
    TargetProtocol[TargetProtocol["NONE"] = 255] = "NONE";
})(TargetProtocol = exports.TargetProtocol || (exports.TargetProtocol = {}));
var CoreType;
(function (CoreType) {
    CoreType[CoreType["M0_CORTEX"] = 1] = "M0_CORTEX";
    CoreType[CoreType["M2_CORTEX"] = 2] = "M2_CORTEX";
    CoreType[CoreType["M3_CORTEX"] = 3] = "M3_CORTEX";
})(CoreType = exports.CoreType || (exports.CoreType = {}));
var NfcPairingMode;
(function (NfcPairingMode) {
    NfcPairingMode[NfcPairingMode["NO"] = 0] = "NO";
    NfcPairingMode[NfcPairingMode["MANDATORY"] = 1] = "MANDATORY";
    NfcPairingMode[NfcPairingMode["MANDATORY_FOR_LOGIN"] = 2] = "MANDATORY_FOR_LOGIN";
})(NfcPairingMode = exports.NfcPairingMode || (exports.NfcPairingMode = {}));
var TargetCoreType;
(function (TargetCoreType) {
    TargetCoreType[TargetCoreType["M0_CORTEX"] = 0] = "M0_CORTEX";
    TargetCoreType[TargetCoreType["M1_CORTEX"] = 1] = "M1_CORTEX";
})(TargetCoreType = exports.TargetCoreType || (exports.TargetCoreType = {}));
var SpecialFeature;
(function (SpecialFeature) {
    SpecialFeature[SpecialFeature["SWD_DIRECT_ACCESS"] = 100] = "SWD_DIRECT_ACCESS";
    SpecialFeature[SpecialFeature["SERIAL_ACCESS"] = 101] = "SERIAL_ACCESS";
    SpecialFeature[SpecialFeature["MODBUS_DIRECT_ACCESS"] = 102] = "MODBUS_DIRECT_ACCESS";
    SpecialFeature[SpecialFeature["TAPNPASS_CONTROL_ACCESS"] = 103] = "TAPNPASS_CONTROL_ACCESS";
    SpecialFeature[SpecialFeature["SP_CODEEXEC_ACCESS"] = 104] = "SP_CODEEXEC_ACCESS";
})(SpecialFeature = exports.SpecialFeature || (exports.SpecialFeature = {}));
var NfcConnectionPriority;
(function (NfcConnectionPriority) {
    NfcConnectionPriority[NfcConnectionPriority["NFC_PRIORITY"] = 0] = "NFC_PRIORITY";
    NfcConnectionPriority[NfcConnectionPriority["NFC_NON_PRIORITY"] = 1] = "NFC_NON_PRIORITY";
})(NfcConnectionPriority = exports.NfcConnectionPriority || (exports.NfcConnectionPriority = {}));
var UartSettings;
(function (UartSettings) {
    var BitParity;
    (function (BitParity) {
        BitParity[BitParity["NONE"] = 0] = "NONE";
        BitParity[BitParity["ODD"] = 1] = "ODD";
        BitParity[BitParity["EVEN"] = 2] = "EVEN";
    })(BitParity = UartSettings.BitParity || (UartSettings.BitParity = {}));
    var Handshake;
    (function (Handshake) {
        Handshake[Handshake["NONE"] = 0] = "NONE";
        Handshake[Handshake["RTS"] = 1] = "RTS";
        Handshake[Handshake["CTS"] = 2] = "CTS";
        Handshake[Handshake["RTS_CTS"] = 3] = "RTS_CTS";
    })(Handshake = UartSettings.Handshake || (UartSettings.Handshake = {}));
    var StopBit;
    (function (StopBit) {
        StopBit[StopBit["ONE"] = 0] = "ONE";
        StopBit[StopBit["ONE_AND_HALF"] = 1] = "ONE_AND_HALF";
        StopBit[StopBit["TWO"] = 2] = "TWO";
    })(StopBit = UartSettings.StopBit || (UartSettings.StopBit = {}));
    var PhysicalPort;
    (function (PhysicalPort) {
        PhysicalPort[PhysicalPort["NONE"] = 0] = "NONE";
        PhysicalPort[PhysicalPort["RS232"] = 1] = "RS232";
        PhysicalPort[PhysicalPort["USB"] = 3] = "USB";
        PhysicalPort[PhysicalPort["AUTO"] = 6] = "AUTO";
        PhysicalPort[PhysicalPort["RS485"] = 10] = "RS485";
    })(PhysicalPort = UartSettings.PhysicalPort || (UartSettings.PhysicalPort = {}));
    var HandshakeDelimiter;
    (function (HandshakeDelimiter) {
        HandshakeDelimiter[HandshakeDelimiter["NONE"] = 0] = "NONE";
        HandshakeDelimiter[HandshakeDelimiter["CR"] = 1] = "CR";
        HandshakeDelimiter[HandshakeDelimiter["LF"] = 2] = "LF";
        HandshakeDelimiter[HandshakeDelimiter["CR_LF"] = 3] = "CR_LF";
    })(HandshakeDelimiter = UartSettings.HandshakeDelimiter || (UartSettings.HandshakeDelimiter = {}));
    var DataBitsLength;
    (function (DataBitsLength) {
        DataBitsLength[DataBitsLength["_7"] = 0] = "_7";
        DataBitsLength[DataBitsLength["_8"] = 1] = "_8";
        DataBitsLength[DataBitsLength["_9"] = 2] = "_9";
    })(DataBitsLength = UartSettings.DataBitsLength || (UartSettings.DataBitsLength = {}));
})(UartSettings = exports.UartSettings || (exports.UartSettings = {}));
var MultiRequest;
(function (MultiRequest) {
    var ExpectedResultCode;
    (function (ExpectedResultCode) {
        ExpectedResultCode[ExpectedResultCode["SUCCESS"] = 127] = "SUCCESS";
        ExpectedResultCode[ExpectedResultCode["ANYTHING"] = 255] = "ANYTHING";
    })(ExpectedResultCode = MultiRequest.ExpectedResultCode || (MultiRequest.ExpectedResultCode = {}));
})(MultiRequest = exports.MultiRequest || (exports.MultiRequest = {}));
var SinglePacket;
(function (SinglePacket) {
    var PacketType;
    (function (PacketType) {
        PacketType[PacketType["MASK"] = 7] = "MASK";
        PacketType[PacketType["DATA_LOG"] = 1] = "DATA_LOG";
        PacketType[PacketType["COMMAND"] = 2] = "COMMAND";
        PacketType[PacketType["CODE_EXEC"] = 3] = "CODE_EXEC";
        PacketType[PacketType["CONF_UPDATE"] = 4] = "CONF_UPDATE";
        PacketType[PacketType["SECURITY_TOKEN"] = 5] = "SECURITY_TOKEN";
        PacketType[PacketType["TARGET_FW_UPDATE"] = 6] = "TARGET_FW_UPDATE";
    })(PacketType = SinglePacket.PacketType || (SinglePacket.PacketType = {}));
})(SinglePacket = exports.SinglePacket || (exports.SinglePacket = {}));
var ModbusOptions;
(function (ModbusOptions) {
    var ObjectType;
    (function (ObjectType) {
        ObjectType[ObjectType["DEFAULT"] = 0] = "DEFAULT";
        ObjectType[ObjectType["COIL"] = 1] = "COIL";
        ObjectType[ObjectType["DISCRET_INPUT"] = 2] = "DISCRET_INPUT";
        ObjectType[ObjectType["HOLDING_REGISTER"] = 3] = "HOLDING_REGISTER";
        ObjectType[ObjectType["INPUT_REGISTER"] = 4] = "INPUT_REGISTER";
    })(ObjectType = ModbusOptions.ObjectType || (ModbusOptions.ObjectType = {}));
})(ModbusOptions = exports.ModbusOptions || (exports.ModbusOptions = {}));
var SinglePacketStoreInfo;
(function (SinglePacketStoreInfo) {
    var State;
    (function (State) {
        State[State["UNAVAILABLE"] = 0] = "UNAVAILABLE";
        State[State["EMPTY"] = 1] = "EMPTY";
        State[State["USED"] = 2] = "USED";
        State[State["FULL"] = 3] = "FULL";
        State[State["ERROR"] = 4] = "ERROR";
    })(State = SinglePacketStoreInfo.State || (SinglePacketStoreInfo.State = {}));
})(SinglePacketStoreInfo = exports.SinglePacketStoreInfo || (exports.SinglePacketStoreInfo = {}));
var AdpControlIn;
(function (AdpControlIn) {
    var Command;
    (function (Command) {
        Command[Command["NONE"] = 0] = "NONE";
        Command[Command["ZIP"] = 32769] = "ZIP";
        Command[Command["UNZIP"] = 32770] = "UNZIP";
        Command[Command["SET_TRANSMISSION_BUFFER_SIZE"] = 32771] = "SET_TRANSMISSION_BUFFER_SIZE";
        Command[Command["TOTAL_BUFFER_SIZE"] = 32772] = "TOTAL_BUFFER_SIZE";
        Command[Command["GET_TRANSMISSION_BUFFER_SIZE"] = 32773] = "GET_TRANSMISSION_BUFFER_SIZE";
        Command[Command["SET_RESPONSE_DELIMITER_LOW"] = 32774] = "SET_RESPONSE_DELIMITER_LOW";
        Command[Command["SET_RESPONSE_DELIMITER_HIGH"] = 32775] = "SET_RESPONSE_DELIMITER_HIGH";
        Command[Command["SET_COMMAND_DELIMITER_LOW"] = 32776] = "SET_COMMAND_DELIMITER_LOW";
        Command[Command["EXEC_COMMANDS"] = 32777] = "EXEC_COMMANDS";
    })(Command = AdpControlIn.Command || (AdpControlIn.Command = {}));
})(AdpControlIn = exports.AdpControlIn || (exports.AdpControlIn = {}));
var AdpControlOut;
(function (AdpControlOut) {
    var ResultCode;
    (function (ResultCode) {
        ResultCode[ResultCode["NONE"] = 0] = "NONE";
        ResultCode[ResultCode["OK"] = 32768] = "OK";
        ResultCode[ResultCode["ZIP_TIMEOUT"] = 32769] = "ZIP_TIMEOUT";
        ResultCode[ResultCode["UNZIP_TIMEOUT"] = 32770] = "UNZIP_TIMEOUT";
        ResultCode[ResultCode["ZIP_ERROR"] = 32771] = "ZIP_ERROR";
        ResultCode[ResultCode["UNZIP_ERROR"] = 32772] = "UNZIP_ERROR";
        ResultCode[ResultCode["UNKNOWN_COMMAND"] = 32773] = "UNKNOWN_COMMAND";
        ResultCode[ResultCode["INVALID_PARAM"] = 32774] = "INVALID_PARAM";
    })(ResultCode = AdpControlOut.ResultCode || (AdpControlOut.ResultCode = {}));
})(AdpControlOut = exports.AdpControlOut || (exports.AdpControlOut = {}));
